import React from "react";
import GlobalStyles from "./styles/GlobalStyles";
import NavBar from "./styles/NavBar";
import Main from "./styles/Main";

function App() {
  return (
    <main>
      <GlobalStyles />
      <NavBar />
      <Main></Main>
    </main>
  );
}

export default App;
